<template>
  <div class="col-12 py-1 py-md-0 pb-md-1 lead-content">
    <div class="pb-md-5 mb-md-5">
      <h1 class="mb-3 lead-title">HOW SWAMPUM WORKS</h1>
      <md-content class="text-content md-elevation-4">
        <div class="lead-banner">
          <div class="text" style="margin-top: 4rem">
            <md-icon class="md-size-2x banner-green" style="margin: 0"
              >groups</md-icon
            >
            <h4 class="banner-text">
              Create and join <strong>groups</strong> of people you’d like to
              <strong>share</strong> with
            </h4>
          </div>

          <div class="text">
            <md-icon md-src="/svg-icons/book-plus.svg" class="md-size-2x" />
            <h4 class="banner-text">
              Post to your account: things you’d like to
              <strong>sell</strong> or <strong>lend</strong>, things you’d like
              to <strong>get</strong> or <strong>borrow</strong>. Maybe even
              some things you’d normally send to the landfill.
            </h4>
          </div>

          <div class="text">
            <md-icon class="md-size-2x banner-tertiary op-75"
              >autorenew</md-icon
            >
            <h4 class="banner-text">
              <strong>Transact</strong> with other users: look for things others
              have that you would like, or help them with something they’re
              looking for
            </h4>
          </div>

          <div class="text">
            <md-icon class="md-size-2x banner-tertiary">public</md-icon>
            <h4 class="banner-text">
              Swampum was built for you to
              <strong style="color: #6da34d">think global</strong> and
              <strong style="color: #395693">act local</strong>. Start sharing
              now with people you care about!
            </h4>
          </div>
        </div>
      </md-content>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowSwampumWorks",
};
</script>

<style lang="scss" scoped>
.lead-content {
  background-color: $light;
  margin: auto;
}
.text-content {
  background-color: $white;
  border-radius: 16px;
}
.banner-text {
  font-size: 20px;
}
.banner-green,
.banner-tertiary {
  margin-left: 0;
}
.banner-green {
  color: $offer !important;
}
.banner-tertiary {
  color: $tertiary !important;
}
.op-75 {
  opacity: 0.75;
}
.lead-banner h4 {
  color: $black !important;
}
</style>

<style lang="scss" scoped>
.lead-title {
  text-align: center;
  font-weight: bold;
  line-height: 36px;
  font-size: 36px;
  letter-spacing: 1.25px;
  padding: 2.5rem !important;
  color: $black;
}
.text-content {
  width: 62rem;
  margin-inline: auto;
}
.text {
  margin-bottom: 2.8rem;
  width: 50rem;
  display: flex;
  align-items: center;
  letter-spacing: 2px;
}
.text h4 {
  margin-left: 4rem;
}
.lead-banner {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: space-around;
}
@media screen and (max-width: 398px) {
  .text {
    width: 15em;
    flex-direction: column;
    margin-bottom: 4rem;
  }
  .text-content {
    height: 75rem;
  }
}
@media screen and (min-width: 398px) and (max-width: 460px) {
  .text {
    width: 19em;
    flex-direction: column;
    margin-bottom: 4rem;
  }
  .text-content {
    height: 65rem;
  }
}
@media screen and (min-width: 460px) and (max-width: 768px) {
  .text {
    width: 31rem;
    flex-direction: column;
    margin-bottom: 4rem;
  }
  .text-content {
    height: 65rem;
  }
}

@media screen and (max-width: 768px) {
  .text h4 {
    text-align: center;
    margin: 0;
  }
  .banner-green,
  .banner-tertiary {
    display: contents;
  }
}

@media (min-width: 1400px) {
  .text-content {
    max-width: 1630px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
